const formattedLikeCount = (counter) => {
  const precision = 1e1;
  const num = { k: 1e3, m: 1e6 };

  if (counter < num.k) {
    return {
      count: counter,
      magnitude: "",
      isRound: true,
    };
  }

  const magnitude = counter < num.m ? "k" : "m";
  const isRound = Number.isInteger((counter / num[magnitude]) * precision);
  const count = Math.floor((counter / num[magnitude]) * precision) / precision;

  return {
    magnitude,
    isRound,
    count,
  };
};

export default formattedLikeCount;
